import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubPortfolioGanttChartComponent } from './sub-portfolio-gantt-chart.component';

const routes: Routes = [
  {
    path: '',
    component: SubPortfolioGanttChartComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubPortfolioGanttChartRoutingModule { }
